import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Contact } from 'components/forms'
import { Button, FormDebug, Title } from 'components/misc'
import { wizard, meta } from 'helpers/decorators'
import { apiCodeLists, apiAwardUnits, apiConfiguration } from 'helpers/decorators/api'
import validate from './award-unit-leader-contact.validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  if (!get(values, 'awardLeaderRegistration.email')) {
    return new Promise(resolve => resolve())
  }

  return props
    .checkEmail({ email: get(values, 'awardLeaderRegistration.email') })
    .then(body => {
      if (get(body, 'value')) {
        // eslint-disable-next-line
        throw {
          awardLeaderRegistration: {
            email: {
              text: 'E-mail address is already in use, if you want to register for another level, please sign in to your account.',
              intlKey: 'errors.email_address_is_in_use_please_sign'
            }
          }
        }
      }
    })
}

@apiConfiguration()
@apiAwardUnits()
@apiCodeLists(['phoneTypes'], { public: true })
@wizard({
  form: 'awardUnitRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate,
  asyncValidate,
  asyncBlurFields: ['awardLeaderRegistration.email']
})
@meta({
  title: 'Nominated Award Leader Contact Details',
  intlKey: 'moduleTitle.nominated_award_leader_contact_details'
})
class AwardUnitLeaderContact extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object
  }

  render() {
    const { handleSubmit, onSubmit, values, errors, codeLists } = this.props
    const selectedCountryIcoCode = get(
      values,
      'helpers.selectedCountry.isoCode'
    )

    const showPhone = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactPhoneNumber.id)


    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.nominated_award_leader_contact_details"
            defaultMessage="Nominated Award Leader Contact Details"
          />
        </Title>

        <Contact
          prefix="awardLeaderRegistration"
          phoneTypes={codeLists.phoneTypes.list}
          selectedCountryIcoCode={selectedCountryIcoCode}
          showPhoneNumber={showPhone}
        />

        <FormDebug values={values} errors={errors} />

        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
    )
  }
}

export default AwardUnitLeaderContact
